/* tslint:disable:no-console */
import 'core-js';
import { flatbuffers } from 'flatbuffers';
import { ServiceAPIFB } from '../src/Protocol/EndeavourProtocol';
import { FetchRequester } from './FetchRequester';
import { Resource, ResourceAttributes } from './OpenTelemetry/Resources';
import { PipelineConfiguration } from './PipelineConfiguration';
import { ResourceModel } from './ResourceModel';
import { ReadableSpan } from './Span';
import { SpanModel } from './SpanModel';
import { Tracer } from './Tracer';
import { EndeavourConfig } from './Types';

export class Endeavour {
  private static instance: Endeavour;
  private resource: Resource = new Resource({});
  private requester: FetchRequester = new FetchRequester(FetchRequester.getDefaultEndeavourEndpoint());
  private tracer: Tracer = new Tracer();
  public optedIn: boolean = false;

  private constructor() {}

  public static initialize(config: EndeavourConfig = {}): Endeavour {
    const instance = new Endeavour();
    instance.resource = config.resource || new Resource({});
    instance.optedIn = config.optedIn || false;
    const endpointUrl = config.url || FetchRequester.getDefaultEndeavourEndpoint();
    instance.requester = new FetchRequester(endpointUrl);
    Endeavour.instance = instance;
    PipelineConfiguration.initialize();
    return Endeavour.instance;
  }

  public static getInstance(): Endeavour {
    if (!Endeavour.instance) {
      Endeavour.instance = Endeavour.initialize();
    }
    return Endeavour.instance;
  }

  public static getTracer(): Tracer {
    return Endeavour.getInstance().tracer;
  }

  public static getResources(): Resource {
    return Endeavour.getInstance().resource;
  }

  public static set optedIn(optedIn: boolean) {
    Endeavour.getInstance().optedIn = optedIn;
  }

  public static get optedIn(): boolean {
    return Endeavour.getInstance().optedIn;
  }

  public static updateResources(attributes: ResourceAttributes): Resource {
    const newResourceAttributes = Object.assign({}, Endeavour.getResources().attributes, attributes);
    const newResource = new Resource(newResourceAttributes);
    Endeavour.instance.resource = Endeavour.instance.resource.merge(newResource);
    return Endeavour.instance.resource;
  }

  public static sendPostSpans(spans: ReadableSpan[]): void {
    // create builder
    const spanModel = new SpanModel();
    const resourceModel = new ResourceModel();
    const builder = new flatbuffers.Builder(1024);

    // create index for spans
    let spanIndexes: number[] = spans.map((span) => spanModel.buildFbSpan(builder, span).valueOf());
    const spanVectorOffset = ServiceAPIFB.PostSpansRequest.createSpansVector(builder, spanIndexes);
    const resourcesOffset = resourceModel.buildResource(builder);
    const postSpansRequest = ServiceAPIFB.PostSpansRequest.createPostSpansRequest(builder, resourcesOffset, spanVectorOffset);
    builder.finish(postSpansRequest);
    Endeavour.instance.requester.postSpans(builder.asUint8Array());
  }

  public static async getPipelineConfigurationReply(): Promise<ServiceAPIFB.GetPipelineConfigurationReply> {
    try {
      const pipelineConfigurationReply: ServiceAPIFB.GetPipelineConfigurationReply = await Endeavour.instance.requester.getPipelineConfigurationReply();
      return pipelineConfigurationReply;
    } catch (err) {
      throw err;
    }
  }
}
